import { Convocatoria, ConvocatoriaDet } from './convocatoria';
import { Departamento } from './departamento';
import { RespuestaOperacionServicio } from './respuestaServicio';
import { Formulario } from './formulario';
import { Persona } from './persona';
import { ParametrosFormulario } from './parametros-form';
import { Parametro } from './parametro';
import { Distrito } from './distrito';
import { Provincia } from './provincia';
import { ParametrosBandeja } from './parametros-bandeja';
import { FiltrosBandeja } from './filtros-bandeja';
import { Paginacion } from './paginacion';
import { Adjunto } from './adjunto';
import { FormularioAuditoria } from './formulario-auditoria';
import { FiltroExt } from './filtro-consulta';
import { FormularioSustento } from './sustento';
import { CargaMasiva } from './carga-masiva';
import { DatosGrafico } from './data-grafico';

// Export
export { RespuestaOperacionServicio,
         Convocatoria,
         ConvocatoriaDet,
         Departamento,
         Formulario,
         Persona,
         ParametrosFormulario,
         Parametro,
         Distrito,
         Provincia,
         ParametrosBandeja,
         FiltrosBandeja,
         Paginacion,
         Adjunto,
         FormularioAuditoria,
         FiltroExt,
         FormularioSustento,
         CargaMasiva,
         DatosGrafico
        };
